import CryptoJS from 'crypto-js';

const SECRET_KEY = 'kaaryaalaya_v2_client_key';

const toUrlSafe = (base64) => base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
const fromUrlSafe = (str) => str.replace(/-/g, '+').replace(/_/g, '/');

export const encryptToUrl = (obj) => {
  const json = JSON.stringify(obj);
  const cipher = CryptoJS.AES.encrypt(json, SECRET_KEY).toString();
  return toUrlSafe(cipher);
};

// Counterpart to encryptToUrl -- accepts either a bare url-safe cipher, or
// one prefixed with "kaarya://" (the shape used for localStorage values).
// Returns null instead of throwing so callers can treat any corrupt/missing
// value the same way as "nothing stored".
export const decryptFromUrl = (raw) => {
  try {
    if (!raw || typeof raw !== 'string') return null;
    const parts = raw.split('://');
    const cipherUrlSafe = parts.length === 2 ? parts[1] : raw;
    const cipher = fromUrlSafe(cipherUrlSafe);
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    if (!json) return null;
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
};

export default {
  encryptToUrl,
  decryptFromUrl,
};
